import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'fx-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.sass'],
})
export class LanguageSelectionComponent implements OnInit {
  langFlag: string[] = ['EN', 'JP', 'VN'];
  selectedLanguageIndex = 0;

  constructor(private translate: TranslateService) {}
  languageHandle() {
    if (this.selectedLanguageIndex + 1 >= this.langFlag.length) {
      this.selectedLanguageIndex = 0;
    } else {
      this.selectedLanguageIndex++;
    }
    this.translate.use(this.langFlag[this.selectedLanguageIndex].toLowerCase());
  }
  ngOnInit() {
    // console.log(this.translate.currentLang);
  }
}
